module.exports = __webpack_public_path__ + "static/media/Nursing.6e229048.webp";